import { Fragment } from "react";

// Matches http(s) URLs and www. URLs, stopping at whitespace or common trailing punctuation.
const URL_RE = /((https?:\/\/|www\.)[^\s<>()]+[^\s<>().,!?;:'"])/gi;

/**
 * Renders text with URLs converted into clickable links.
 * Preserves line breaks. Internal links (same origin) open in the same tab;
 * external ones open in a new tab.
 */
export function Linkify({ text, className }: { text: string; className?: string }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  URL_RE.lastIndex = 0;
  let key = 0;

  while ((match = URL_RE.exec(text)) !== null) {
    const start = match.index;
    const raw = match[0];
    if (start > lastIndex) parts.push(<Fragment key={`t-${key++}`}>{text.slice(lastIndex, start)}</Fragment>);
    const href = raw.startsWith("http") ? raw : `https://${raw}`;
    const isInternal = origin && href.startsWith(origin);
    parts.push(
      <a
        key={`a-${key++}`}
        href={href}
        target={isInternal ? undefined : "_blank"}
        rel={isInternal ? undefined : "noopener noreferrer"}
        onClick={(e) => e.stopPropagation()}
        className="underline decoration-current/40 underline-offset-2 hover:decoration-current break-all"
      >
        {raw}
      </a>,
    );
    lastIndex = start + raw.length;
  }
  if (lastIndex < text.length) parts.push(<Fragment key={`t-${key++}`}>{text.slice(lastIndex)}</Fragment>);

  return <span className={className} style={{ whiteSpace: "pre-wrap" }}>{parts}</span>;
}
